import React from 'react';

export namespace GalleryEditorHelper {
  export const getScaleFromElement = (el: HTMLElement) => {
    return getScale(el.style as React.CSSProperties);
  };

  export const getScale = (style: React.CSSProperties) => {
    const transform = style.transform ? style.transform.toString() : '';
    const scaleX = transform.match(/scaleX\(([^)]+)\)/);
    const scaleY = transform.match(/scaleY\(([^)]+)\)/);
    return scaleX ? parseFloat(scaleX[1]) : scaleY ? parseFloat(scaleY[1]) : 1;
  };

  export const getThumbnailCSS = (scale: number): React.CSSProperties => {
    return scale < 0.9
      ? {
          borderWidth: '0.8rem',
          borderRadius: '1.6rem',
        }
      : scale > 1.1
        ? {
            borderWidth: '0.2rem',
            borderRadius: '0.4rem',
          }
        : {};
  };

  export const getThumbnailWrapperCSS = (
    isPrimary: boolean,
  ): React.CSSProperties => {
    return isPrimary
      ? {
          gridRowStart: 'span 2',
          gridColumnStart: 'span 2',
          height:
            'calc(2 * var(--thumbnail-height) + var(--gallery-thumbnail-gap))',
        }
      : {
          gridRowStart: '',
          gridColumnStart: '',
          height: 'var(--gallery-thumbnail-height)',
        };
  };
}
